export default __webpack_public_path__ + "static/icons-01-03-9eefbb57c08d7792bbb788625428efda.png";